<div>

  <form [formGroup]="formRetrofitTimespan" style="margin-top: 36px; width: 100%;">
    <div style="font-size: 14px; font-weight: 500;">
      Construction Time Span
      <mat-divider [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
    </div>

    <div style="margin-top: 12px;">
      <mat-form-field style="width:240px;" appearance="outline" id="constructionStartDateField" class="error-push-down">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="pickerConstructionStart" required autocomplete="off"
          [min]="application.acceptedDate | date:'yyyy-MM-dd HH:mm:ss'"
          placeholder="Start Date"
          id="constructionStartDate"
          name="constructionStartDate"
          aria-labelledby="constructionStartDate"
          formControlName="constructionStartDate">
          <mat-datepicker-toggle matSuffix [for]="pickerConstructionStart" [startAt]="application.acceptedDate | date:'yyyy-MM-dd HH:mm:ss'"></mat-datepicker-toggle>
          <mat-datepicker #pickerConstructionStart></mat-datepicker>
          @if (onCheckTimespanControlValidators('constructionStartDate')) {
            <mat-error
              >
              Start date required on/after {{application.acceptedDate | date:'MM/dd/yyyy'}}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field style="width: 240px;" appearance="outline" id="constructionEndDateField" class="error-push-down">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="pickerConstructionEnd" required autocomplete="off"
            [min]="application.acceptedDate | date:'yyyy-MM-dd HH:mm:ss'"
            placeholder="End Date"
            id="constructionEndDate"
            name="constructionEndDate"
            aria-labelledby="constructionEndDate"
            [errorStateMatcher]="crossFieldErrorMatcherConstructionDates"
            formControlName="constructionEndDate">
            <mat-datepicker-toggle matSuffix [for]="pickerConstructionEnd" [startAt]="application.acceptedDate | date:'yyyy-MM-dd HH:mm:ss'"></mat-datepicker-toggle>
            <mat-datepicker #pickerConstructionEnd></mat-datepicker>
            <!-- <mat-error
            *ngIf="onCheckTimespanControlValidators('constructionEndDate')">
            End date required on/after {{application.acceptedDate | date:'MM/dd/yyyy'}}
          </mat-error> -->
          @if (formRetrofitTimespan.hasError('startEndDateOrder')) {
            <mat-error
              >
              End date before Start date
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field style="width: 240px;" appearance="outline" id="constructionNumberOfDaysField" class="error-push-down">
          <mat-label>Actual Construction Days</mat-label>
          <input matInput required autocomplete="off"
            mask="0*"
            placeholder="Actual Construction Days"
            id="constructionNumberOfDays"
            name="constructionNumberOfDays"
            aria-labelledby="constructionNumberOfDays"
            formControlName="constructionNumberOfDays">
            @if (onCheckTimespanControlValidators('constructionNumberOfDays')) {
              <mat-error
                >
                Days required
              </mat-error>
            }
            @if (maxDaysValidator(formRetrofitTimespan)) {
              <mat-hint
                >
                Too many days
              </mat-hint>
            }
          </mat-form-field>

          @if ((taskItemRejectedConstruction === true &&
            maxDaysValidator(formRetrofitTimespan) === false &&
            (onCheckTimespanControlValidators('constructionNumberOfDays') === false ||
            onCheckTimespanControlValidators('constructionNumberOfDays') === null)) ||
            (taskItemRejectedConstruction === true && innerWidth >= 1000)) {
            <p
              class="warn-text"
              style="margin-bottom: 6px;">
              Action required
              <span style="white-space:nowrap;">
                (<a style='color: #29637C; font-size: 16px; font-weight: 400;' role="button"
                tabindex="2"
                href="javascript:void(0)"
              (click)='onClickShowReasonWhy(taskItemRejectedConstructionReasonWhy)'>read why</a>)
            </span>
          </p>
        }

        @if (taskItemRejectedConstruction === true &&
          (maxDaysValidator(formRetrofitTimespan) === true ||
          onCheckTimespanControlValidators('constructionNumberOfDays')) &&
          innerWidth < 1000) {
          <p
            class="warn-text"
            style="margin-bottom: 6px;">
            Action required
            <span style="white-space:nowrap;">
              (<a style='color: #29637C; font-size: 16px; font-weight: 400;' role="button"
              tabindex="0"
              href="javascript:void(0)"
            (click)='onClickShowReasonWhy(taskItemRejectedConstructionReasonWhy)'>read why</a>)
          </span>
        </p>
      }

    </div>

    <div style="font-size: 14px; font-weight: 500;">
      Inspection
      <mat-divider [ngStyle]="{'width': '90%'}" ngStyle.lt-lg="{'width': '100%'}"></mat-divider>
    </div>

    <div style="margin-top: 12px;">
      <mat-form-field style="width: 240px;" appearance="outline" class="error-push-down">
        <mat-label>Inspector Name</mat-label>
        <input matInput required autocomplete="off"
          id="inspectorFullname"
          name="inspectorFullname"
          aria-labelledby="inspectorFullname"
          formControlName="inspectorFullname">
          @if (onCheckTimespanControlValidators('inspectorFullname')) {
            <mat-error
              >
              Inspector name required
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field style="width:240px; margin-right: 25px;" appearance="outline" id="inspectionDateField" class="error-push-down">
          <mat-label>Date of Inspection</mat-label>
          <input matInput [matDatepicker]="pickerInspectionDate" required autocomplete="off"
            [min]="application.acceptedDate | date:'yyyy-MM-dd HH:mm:ss'"
            id="inspectionDate"
            name="inspectionDate"
            aria-labelledby="inspectionDate"
            formControlName="inspectionDate">
            <mat-datepicker-toggle matSuffix [for]="pickerInspectionDate" [startAt]="application.acceptedDate | date:'yyyy-MM-dd HH:mm:ss'"></mat-datepicker-toggle>
            <mat-datepicker #pickerInspectionDate></mat-datepicker>
            @if (onCheckTimespanControlValidators('inspectionDate')) {
              <mat-error
                >
                Inspection date required on/after {{application.acceptedDate | date:'MM/dd/yyyy'}}
              </mat-error>
            }
          </mat-form-field>

          @if (taskItemRejectedInspection === true) {
            <p class="warn-text" style="margin-bottom: 6px;">
              Action required
              <span style="white-space:nowrap;">
                (<a style='color: #29637C; font-size: 16px; font-weight: 400;' role="button"
                tabindex="1"
                href="javascript:void(0)"
              (click)='onClickShowReasonWhy(taskItemRejectedInspectionReasonWhy)'>read why</a>)
            </span>
          </p>
        }

      </div>

      <button mat-raised-button color="primary"
        type="submit"
        (click)="onClickSaveRetrofitTimespan()"
        [disabled]="formRetrofitTimespan.pristine || formRetrofitTimespan.invalid">
        SAVE
      </button>
      @if (formAutoSaveTimespan) {
        <div style="margin-top: 12px;" role="status" aria-live="polite">
          <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
        </div>
      }
    </form>
  </div>